/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface CalendarConnectionOut {
  id: string;
  provider: string;
  email_address: string;
  status: string;
  user_id: string | null;
  connected_at: string | null;
  last_sync_at: string | null;
  disconnect_reason: string | null;
}
